import {
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	makeStyles,
	ListItemText,
	TextField,
	Typography
} from '@material-ui/core'

import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { DeletableChip } from '../../Misc/DeletableChip'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(378px, 1fr))',
		marginBottom: '50px'
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const Configurations = (props) => {
	let { selectedFacility, setCurrent } = props

	const classes = useStyles()
	const [vaccines, setVaccines] = useState([])
	const vaccineOptions = useSelector((state) => state.general.constants.required_vaccines)

	useEffect(() => {
		if (Array.isArray(selectedFacility.vaccines_required)) {
			setVaccines(
				selectedFacility.vaccines_required.map((v) => {
					let foundIndex = vaccineOptions.findIndex((vo) => vo.id === v.id)
					if (foundIndex !== -1) {
						return vaccineOptions[foundIndex]
					}
				})
			)
		}
	}, [vaccineOptions, selectedFacility.vaccines_required])

	const removeVaccines = (vaccine) => {
		let updatedVaccines = [...selectedFacility.vaccines_required]
		let vaccinesIndex = updatedVaccines.findIndex((v) => v.id === vaccine.id)

		if (vaccinesIndex !== -1) {
			updatedVaccines.splice(vaccinesIndex, 1)
		}

		setCurrent({ ...selectedFacility, vaccines_required: updatedVaccines })
	}

	return (
		<Card style={{ maxWidth: '1245px' }}>
			<CardHeader title="Configurations" />
			<CardContent>
				<Typography style={{ fontWeight: '800', fontSize: '16px', marginBottom: '20px' }}>
					Required Vaccines
				</Typography>
				<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
					<Autocomplete
						multiple
						getOptionLabel={(option) => option.name}
						disableCloseOnSelect
						size="small"
						id="vaccines-required"
						className={classes.autoComplete}
						options={vaccineOptions}
						value={vaccines}
						onChange={(e, v) => setCurrent({ ...selectedFacility, vaccines_required: v })}
						onClose={(e) => {
							e.target.value = ''
						}}
						disabled={!selectedFacility.active}
						renderTags={(selected) =>
							selected.map((value) => (
								<DeletableChip
									key={value.id}
									label={value.name}
									{...{
										onDelete: selectedFacility.active ? () => removeVaccines(value) : null
									}}
								/>
							))
						}
						renderOption={(option, { selected }) => (
							<React.Fragment>
								<Checkbox checked={selected} />
								<ListItemText style={{ textTransform: 'capitalize' }} primary={option.name} />
							</React.Fragment>
						)}
						renderInput={(params) => (
							<TextField {...params} fullWidth variant="filled" label="Required Vaccines" />
						)}
					/>
				</div>
			</CardContent>
		</Card>
	)
}

export default Configurations
